import React, {useState} from 'react';
import Popup from '../common/components/Popup';
import PopupWarningContent from './PopupWarningContent';
import Select from 'react-select';
import {SELECT_PLACEHOLDER} from '../../constants/permission';
import CustomDropdownIndicator from '../common/components/CustomDropdownIndicator';


interface changeRoleProps {
    showPopup: boolean,
    userRoleId: string,
    userRoles?: {userRoleId: string, userRoleName: string}[],
    showDropdown?: boolean,
    onClose: (show: boolean) => void,
    onChangeRole: (userRoleId: string) => Promise<boolean> | void,
}

function ChangeRole(props: changeRoleProps) {
    const {showPopup, showDropdown, userRoles, userRoleId,
        onClose, onChangeRole} = props;

    const [
        selectedUserRole,
        setSelectedUserRole,
    ] = useState<{value: string, label: string}>({
        value: SELECT_PLACEHOLDER,
        label: SELECT_PLACEHOLDER,
    });
    const [
        loading,
        setLoading,
    ] = useState(false);

    const handleSelectRole = (role: any) => {
        setSelectedUserRole({value: role.value, label: role.label});
    };

    const handleClose = () => {
        setSelectedUserRole({value: SELECT_PLACEHOLDER,
            label: SELECT_PLACEHOLDER});
        onClose(false);
    };

    const handleChangeRole = async () => {
        setLoading(true);
        await onChangeRole(showDropdown ? selectedUserRole.value : userRoleId);
        setSelectedUserRole({
            value: SELECT_PLACEHOLDER, label: SELECT_PLACEHOLDER});
        setLoading(false);
    };

    return (
        <Popup
            show={showPopup}
            onClose={handleClose}
            title='Change Role'
            size='lg'
            primaryCtaText={showDropdown ? 'Confirm Change' : 'I understand'}
            primaryCtaLoading={loading}
            disablePrimaryCta={showDropdown &&
                selectedUserRole.value === SELECT_PLACEHOLDER}
            primaryCtaOnClick={handleChangeRole}
            secondaryCtaText={showDropdown ? 'Cancel' : 'Undo'}
            secondaryCtaOnClick={handleClose}
            customClassName='manage-user-menu-popup'
        >
            <PopupWarningContent mainContent='Changing user’s role will may affect user’s ability to perform certain tasks and may limit access to certain information.'/>
            {showDropdown && (
                <div className='manage-user-detail-page'>
                    <label className='form-label mt-2'>Change Role</label>
                    <Select
                        options={userRoles?.filter((item) =>
                            item.userRoleId !== userRoleId).map((role) => {
                            return {value: role.userRoleId,
                                label: role.userRoleName}
                        })}
                        value={selectedUserRole}
                        placeholder={'Select Role'}
                        isSearchable
                        onChange={handleSelectRole}
                        className='input-select'
                        components={{
                            DropdownIndicator: CustomDropdownIndicator}}
                        styles={{
                            indicatorSeparator: (base) => ({
                                ...base,
                                display: 'none',
                            }),
                        }}
                    ></Select>
                </div>
            )}
        </Popup>
    );
}

export default ChangeRole;
